// Action Types

export const Types = {
    GET_LEGAL_SOLICITATIONS_REQUESTED: 'management/GET_LEGAL_SOLICITATIONS_REQUESTED',
    GET_LEGAL_SOLICITATIONS_SUCCEEDED: 'management/GET_LEGAL_SOLICITATIONS_SUCCEEDED',
    GET_LEGAL_SOLICITATIONS_FAILED: 'management/GET_LEGAL_SOLICITATIONS_FAILED',
  
    POST_LEGAL_SOLICITATION_REQUESTED: 'management/POST_LEGAL_SOLICITATION_REQUESTED',
    POST_LEGAL_SOLICITATION_SUCCEEDED: 'management/POST_LEGAL_SOLICITATION_SUCCEEDED',
    POST_LEGAL_SOLICITATION_FAILED: 'management/POST_LEGAL_SOLICITATION_FAILED',
  
    GET_LEGAL_SOLICITATION_RESPONSES_REQUESTED: 'management/GET_LEGAL_SOLICITATION_RESPONSES_REQUESTED',
    GET_LEGAL_SOLICITATION_RESPONSES_SUCCEEDED: 'management/GET_LEGAL_SOLICITATION_RESPONSES_SUCCEEDED',
    GET_LEGAL_SOLICITATION_RESPONSES_FAILED: 'management/GET_LEGAL_SOLICITATION_RESPONSES_FAILED',
  
    POST_LEGAL_SOLICITATION_RESPONSE_REQUESTED: 'management/POST_LEGAL_SOLICITATION_RESPONSE_REQUESTED',
    POST_LEGAL_SOLICITATION_RESPONSE_SUCCEEDED: 'management/POST_LEGAL_SOLICITATION_RESPONSE_SUCCEEDED',
    POST_LEGAL_SOLICITATION_RESPONSE_FAILED: 'management/POST_LEGAL_SOLICITATION_RESPONSE_FAILED',
  
    GET_OFFICIAL_LETTERS_CREATED_REQUESTED: 'management/GET_OFFICIAL_LETTERS_CREATED_REQUESTED',
    GET_OFFICIAL_LETTERS_CREATED_SUCCEEDED: 'management/GET_OFFICIAL_LETTERS_CREATED_SUCCEEDED',
    GET_OFFICIAL_LETTERS_CREATED_FAILED: 'management/GET_OFFICIAL_LETTERS_CREATED_FAILED',
  
    POST_OFFICIAL_LETTER_CREATED_REQUESTED: 'management/POST_OFFICIAL_LETTER_CREATED_REQUESTED',
    POST_OFFICIAL_LETTER_CREATED_SUCCEEDED: 'management/POST_OFFICIAL_LETTER_CREATED_SUCCEEDED',
    POST_OFFICIAL_LETTER_CREATED_FAILED: 'management/POST_OFFICIAL_LETTER_CREATED_FAILED',
  
    GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED: 'management/GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED',
    GET_OFFICIAL_LETTERS_RECEIVED_SUCCEEDED: 'management/GET_OFFICIAL_LETTERS_RECEIVED_SUCCEEDED',
    GET_OFFICIAL_LETTERS_RECEIVED_FAILED: 'management/GET_OFFICIAL_LETTERS_RECEIVED_FAILED',
  
    POST_OFFICIAL_LETTER_RECEIVED_REQUESTED: 'management/POST_OFFICIAL_LETTER_RECEIVED_REQUESTED',
    POST_OFFICIAL_LETTER_RECEIVED_SUCCEEDED: 'management/POST_OFFICIAL_LETTER_RECEIVED_SUCCEEDED',
    POST_OFFICIAL_LETTER_RECEIVED_FAILED: 'management/POST_OFFICIAL_LETTER_RECEIVED_FAILED',
  
    UPDATE_STATUS_REQUESTED: 'management/UPDATE_STATUS_REQUESTED',
    UPDATE_STATUS_SUCCEEDED: 'management/UPDATE_STATUS_SUCCEEDED',
    UPDATE_STATUS_FAILED: 'management/UPDATE_STATUS_FAILED',
  
    UPDATE_OFFICIAL_LETTER_REQUESTED: 'management/UPDATE_OFFICIAL_LETTER_REQUESTED',
    UPDATE_OFFICIAL_LETTER_SUCCEEDED: 'management/UPDATE_OFFICIAL_LETTER_SUCCEEDED',
    UPDATE_OFFICIAL_LETTER_FAILED: 'management/UPDATE_OFFICIAL_LETTER_FAILED',
  
    GENERATE_LEGAL_DEMAND_FOR_OFICIO_REQUESTED: 'management/GENERATE_LEGAL_DEMAND_FOR_OFICIO_REQUESTED',
    GENERATE_LEGAL_DEMAND_FOR_OFICIO_SUCCEEDED: 'management/GENERATE_LEGAL_DEMAND_FOR_OFICIO_SUCCEEDED',
    GENERATE_LEGAL_DEMAND_FOR_OFICIO_FAILED: 'management/GENERATE_LEGAL_DEMAND_FOR_OFICIO_FAILED',
  
    GET_PORTAIS_REQUESTED: 'management/GET_PORTAIS_REQUESTED',
    GET_PORTAIS_SUCCEEDED: 'management/GET_PORTAIS_SUCCEEDED',
    GET_PORTAIS_FAILED: 'management/GET_PORTAIS_FAILED',
  
    POST_PORTAL_REQUESTED: 'management/POST_PORTAL_REQUESTED',
    POST_PORTAL_SUCCEEDED: 'management/POST_PORTAL_SUCCEEDED',
    POST_PORTAL_FAILED: 'management/POST_PORTAL_FAILED',
  }
  
  // Action Creators
  
  export function getLegalSolicitations(payload) {
    return {
      type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED,
      payload,
    }
  }
  
  export function postLegalSolicitation(payload) {
    return {
      type: Types.POST_LEGAL_SOLICITATION_REQUESTED,
      payload,
    }
  }
  
  export function getLegalSolicitationResponses(payload) {
    return {
      type: Types.GET_LEGAL_SOLICITATION_RESPONSES_REQUESTED,
      payload,
    }
  }
  
  export function postLegalSolicitationResponse(payload) {
    return {
      type: Types.POST_LEGAL_SOLICITATION_RESPONSE_REQUESTED,
      payload,
    }
  }
  
  export function getOfficialLettersCreated(payload) {
    return {
      type: Types.GET_OFFICIAL_LETTERS_CREATED_REQUESTED,
      payload,
    }
  }
  
  export function postOfficialLetterCreated(payload) {
    return {
      type: Types.POST_OFFICIAL_LETTER_CREATED_REQUESTED,
      payload,
    }
  }
  
  export function getOfficialLettersReceived(payload) {
    return {
      type: Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED,
      payload,
    }
  }
  
  export function postOfficialLetterReceived(payload) {
    return {
      type: Types.POST_OFFICIAL_LETTER_RECEIVED_REQUESTED,
      payload,
    }
  }
  
  export function updateStatus(payload) {
    return {
      type: Types.UPDATE_STATUS_REQUESTED,
      payload,
    }
  }
  
  export function updateOfficialLetter(payload) {
    return {
      type: Types.UPDATE_OFFICIAL_LETTER_REQUESTED,
      payload,
    }
  }
  
  export function generateLegalDemandForOficio(payload) {
    return {
      type: Types.GENERATE_LEGAL_DEMAND_FOR_OFICIO_REQUESTED,
      payload,
    }
  }
  
  export function getPortais(payload) {
    return {
      type: Types.GET_PORTAIS_REQUESTED,
      payload,
    }
  }
  
  export function postPortal(payload) {
    return {
      type: Types.POST_PORTAL_REQUESTED,
      payload,
    }
  }
  
  // Reducer
  
  const INITIAL_STATE = {
    getLegalSolicitationsIsLoading: false,
    getLegalSolicitationsError: null,
    legalSolicitations: [],
  
    postLegalSolicitationIsLoading: false,
    postLegalSolicitationError: null,
  
    getLegalSolicitationResponsesIsLoading: false,
    getLegalSolicitationResponsesError: null,
    legalSolicitationResponses: [],
  
    postLegalSolicitationResponseIsLoading: false,
    postLegalSolicitationResponseError: null,
  
    getOfficialLettersCreatedIsLoading: false,
    getOfficialLettersCreatedError: null,
    officialLettersCreated: [],
  
    postOfficialLetterCreatedIsLoading: false,
    postOfficialLetterCreatedError: null,
  
    getOfficialLettersReceivedIsLoading: false,
    getOfficialLettersReceivedError: null,
    officialLettersReceived: [],
  
    postOfficialLetterReceivedIsLoading: false,
    postOfficialLetterReceivedError: null,
  
    updateStatusIsLoading: false,
    updateStatusError: null,
  
    updateOfficialLetterIsLoading: false,
    updateOfficialLetterError: null,
  
    generateLegalDemandForOficioIsLoading: false,
    generateLegalDemandForOficioError: null,
  
    getPortaisIsLoading: false,
    getPortaisError: null,
    portais: [],
  
    postPortalIsLoading: false,
    postPortalError: null,
  }
  
  export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
      case Types.GET_LEGAL_SOLICITATIONS_REQUESTED:
        return { ...state, getLegalSolicitationsIsLoading: true }
      case Types.GET_LEGAL_SOLICITATIONS_SUCCEEDED:
        return { ...state, getLegalSolicitationsIsLoading: false, legalSolicitations: action.payload }
      case Types.GET_LEGAL_SOLICITATIONS_FAILED:
        return { ...state, getLegalSolicitationsIsLoading: false, getLegalSolicitationsError: action.payload }
  
      case Types.POST_LEGAL_SOLICITATION_REQUESTED:
        return { ...state, postLegalSolicitationIsLoading: true }
      case Types.POST_LEGAL_SOLICITATION_SUCCEEDED:
        return { ...state, postLegalSolicitationIsLoading: false }
      case Types.POST_LEGAL_SOLICITATION_FAILED:
        return { ...state, postLegalSolicitationIsLoading: false, postLegalSolicitationError: action.payload }
  
      case Types.GET_LEGAL_SOLICITATION_RESPONSES_REQUESTED:
        return { ...state, getLegalSolicitationResponsesIsLoading: true, legalSolicitationResponses: [] }
      case Types.GET_LEGAL_SOLICITATION_RESPONSES_SUCCEEDED:
        return { ...state, getLegalSolicitationResponsesIsLoading: false, legalSolicitationResponses: action.payload }
      case Types.GET_LEGAL_SOLICITATION_RESPONSES_FAILED:
        return { ...state, getLegalSolicitationResponsesIsLoading: false, getLegalSolicitationResponsesError: action.payload }
  
      case Types.POST_LEGAL_SOLICITATION_RESPONSE_REQUESTED:
        return { ...state, postLegalSolicitationResponseIsLoading: true }
      case Types.POST_LEGAL_SOLICITATION_RESPONSE_SUCCEEDED:
        return { ...state, postLegalSolicitationResponseIsLoading: false }
      case Types.POST_LEGAL_SOLICITATION_RESPONSE_FAILED:
        return { ...state, postLegalSolicitationResponseIsLoading: false, postLegalSolicitationResponseError: action.payload }
  
      case Types.GET_OFFICIAL_LETTERS_CREATED_REQUESTED:
        return { ...state, getOfficialLettersCreatedIsLoading: true }
      case Types.GET_OFFICIAL_LETTERS_CREATED_SUCCEEDED:
        return { ...state, getOfficialLettersCreatedIsLoading: false, officialLettersCreated: action.payload }
      case Types.GET_OFFICIAL_LETTERS_CREATED_FAILED:
        return { ...state, getOfficialLettersCreatedIsLoading: false, getOfficialLettersCreatedError: action.payload }
  
      case Types.POST_OFFICIAL_LETTER_CREATED_REQUESTED:
        return { ...state, postOfficialLetterCreatedIsLoading: true, postOfficialLetterCreatedError: null }
      case Types.POST_OFFICIAL_LETTER_CREATED_SUCCEEDED:
        return { ...state, postOfficialLetterCreatedIsLoading: false, postOfficialLetterCreatedError: null }
      case Types.POST_OFFICIAL_LETTER_CREATED_FAILED:
        return { ...state, postOfficialLetterCreatedIsLoading: false, postOfficialLetterCreatedError: action.payload }
  
      case Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED:
        return { ...state, getOfficialLettersReceivedIsLoading: true }
      case Types.GET_OFFICIAL_LETTERS_RECEIVED_SUCCEEDED:
        return { ...state, getOfficialLettersReceivedIsLoading: false, officialLettersReceived: action.payload }
      case Types.GET_OFFICIAL_LETTERS_RECEIVED_FAILED:
        return { ...state, getOfficialLettersReceivedIsLoading: false, getOfficialLettersReceivedError: action.payload }
  
      case Types.POST_OFFICIAL_LETTER_RECEIVED_REQUESTED:
        return { ...state, postOfficialLetterReceivedIsLoading: true, postOfficialLetterReceivedError: null }
      case Types.POST_OFFICIAL_LETTER_RECEIVED_SUCCEEDED:
        return { ...state, postOfficialLetterReceivedIsLoading: false, postOfficialLetterReceivedError: null }
      case Types.POST_OFFICIAL_LETTER_RECEIVED_FAILED:
        return { ...state, postOfficialLetterReceivedIsLoading: false, postOfficialLetterReceivedError: action.payload }
  
      case Types.UPDATE_STATUS_REQUESTED:
        return { ...state, updateStatusIsLoading: true }
      case Types.UPDATE_STATUS_SUCCEEDED:
        return { ...state, updateStatusIsLoading: false }
      case Types.UPDATE_STATUS_FAILED:
        return { ...state, updateStatusIsLoading: false, updateStatusError: action.payload }
  
      case Types.UPDATE_OFFICIAL_LETTER_REQUESTED:
        return { ...state, updateOfficialLetterIsLoading: true }
      case Types.UPDATE_OFFICIAL_LETTER_SUCCEEDED:
        return { ...state, updateOfficialLetterIsLoading: false }
      case Types.UPDATE_OFFICIAL_LETTER_FAILED:
        return { ...state, updateOfficialLetterIsLoading: false, updateOfficialLetterError: action.payload }
  
      case Types.GENERATE_LEGAL_DEMAND_FOR_OFICIO_REQUESTED:
        return { ...state, generateLegalDemandForOficioIsLoading: true }
      case Types.GENERATE_LEGAL_DEMAND_FOR_OFICIO_SUCCEEDED:
        return { ...state, generateLegalDemandForOficioIsLoading: false }
      case Types.GENERATE_LEGAL_DEMAND_FOR_OFICIO_FAILED:
        return { ...state, generateLegalDemandForOficioIsLoading: false, generateLegalDemandForOficioError: action.payload }
  
      case Types.GET_PORTAIS_REQUESTED:
        return { ...state, getPortaisIsLoading: true }
      case Types.GET_PORTAIS_SUCCEEDED:
        return { ...state, getPortaisIsLoading: false, portais: action.payload }
      case Types.GET_PORTAIS_FAILED:
        return { ...state, getPortaisIsLoading: false, getPortaisError: action.payload }
  
      case Types.POST_PORTAL_REQUESTED:
        return { ...state, postPortalIsLoading: true }
      case Types.POST_PORTAL_SUCCEEDED:
        return { ...state, postPortalIsLoading: false }
      case Types.POST_PORTAL_FAILED:
        return { ...state, postPortalIsLoading: false, postPortalError: action.payload }
  
      default:
        return state
    }
  }